import { render, staticRenderFns } from "./PatternsPage.vue?vue&type=template&id=7b1209c8&"
import script from "./PatternsPage.vue?vue&type=script&lang=js&"
export * from "./PatternsPage.vue?vue&type=script&lang=js&"
import style0 from "./PatternsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports